import { Box, FormControl, MenuItem, OutlinedInput, Select, type SelectChangeEvent } from '@mui/material'
import React from 'react'

import type { GridFilterOption } from '../types'

type Props = {
	value: string
	options: GridFilterOption[]
	placeholder: string
	onChange: (value: string) => void
}

export const SelectFilter: React.FC<Props> = ({ value, options, placeholder, onChange }) => (
	<FormControl fullWidth size="small" variant="standard" onClick={(e) => e.stopPropagation()}>
		<Select
			value={value}
			onChange={(e: SelectChangeEvent<string>) => onChange(e.target.value)}
			onKeyDown={(e) => e.stopPropagation()}
			displayEmpty
			renderValue={(selected) => {
				if (selected === '' || selected === undefined) {
					return <Box sx={{ color: 'text.disabled', py: '3px' }}>{placeholder}</Box>
				}
				const option = options.find((opt) => opt.value === selected)
				return <Box sx={{ py: '3px' }}>{option?.label ?? selected}</Box>
			}}
			input={<OutlinedInput size="small" />}
		>
			<MenuItem value="">
				<em>{placeholder || '—'}</em>
			</MenuItem>
			{options.map((opt) => (
				<MenuItem key={opt.value} value={opt.value}>
					{opt.label}
				</MenuItem>
			))}
		</Select>
	</FormControl>
)
